import storage from "redux-persist/lib/storage";
export const authPersist = {
  key: "pds",
  storage,
};

export const statePersist = {
  key: "state",
  storage,
};
